var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommentAttachment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.35225 19.1301C-0.0533587 16.8473 -0.152706 13.0534 2.13013 10.6478L10.0149 2.33892C11.6745 0.590106 14.4351 0.517817 16.1839 2.17738C17.9327 3.83694 18.005 6.59756 16.3455 8.34638L9.96253 15.0726C8.92625 16.1646 7.19893 16.2098 6.10691 15.1735C5.01489 14.1373 4.96966 12.4099 6.00595 11.3179L11.6379 5.38303L13.2206 6.8849L7.521 12.891C7.10798 13.3262 7.8993 14.0772 8.31231 13.6419L14.7628 6.84451C15.5888 5.97406 15.5525 4.58604 14.6821 3.76001C13.8116 2.93399 12.4236 2.97033 11.5976 3.84078L3.71276 12.1496C2.26346 13.6769 2.32687 16.0982 3.85411 17.5475C5.38135 18.9968 7.80269 18.9334 9.25199 17.4061L16.3858 9.88863L17.9685 11.3905L10.8346 18.908C8.55179 21.3136 4.75785 21.413 2.35225 19.1301Z",
    fill: "#8C8C8C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentAttachment);
export default __webpack_public_path__ + "static/media/CommentAttachment.0b0e8f6e518d33f74a83cca2dcf60eeb.svg";
export { ForwardRef as ReactComponent };